import { render, staticRenderFns } from "./TabNameCard.vue?vue&type=template&id=2ee9d2e8&scoped=true&"
import script from "./TabNameCard.vue?vue&type=script&lang=js&"
export * from "./TabNameCard.vue?vue&type=script&lang=js&"
import style0 from "./TabNameCard.vue?vue&type=style&index=0&id=2ee9d2e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9d2e8",
  null
  
)

export default component.exports